import { getSellerFulfillmentProviderIdFromShipFromId, isShipFromExternal } from '../../store/csw/csw.fulfillment-plan-to-csw';

export const calculateShipFromIdAndSellerFulfillmentProviderId = (id) => {
  if (isShipFromExternal(id)) {
    return {
      sellerFulfillmentProviderId: getSellerFulfillmentProviderIdFromShipFromId(id),
      shipFromId: null,
    };
  }
  return {
    sellerFulfillmentProviderId: null,
    shipFromId: id,
  };
};
